exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar.search-open-mobil .search-result.active[data-v-6dddd70f] {\n  opacity: 1;\n}\n.navbar.search-open-mobil .form-search-mobil[data-v-6dddd70f] {\n  overflow: visible;\n}\n.navbar .search-result[data-v-6dddd70f] {\n  z-index: 100;\n  padding: 1rem;\n  opacity: 0;\n  overflow: scroll;\n  max-height: 600px;\n  transition: all 0.2s ease-in-out;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n}", ""]);

// exports
